import { z } from 'zod';
import { eventSchema } from './envelope';

export const AUDIT_EXPORTED_V1 = 'audit.exported.v1' as const;

/** Het auditspoor zelf is geëxporteerd: ook dat hoort in het spoor (Stap 18). */
export const auditExportedV1Schema = eventSchema({
  rows: z.number().int(),
  filter: z.record(z.string(), z.string()),
});
export type AuditExportedV1 = z.infer<typeof auditExportedV1Schema>;
